import { render, staticRenderFns } from "./AssistantService.vue?vue&type=template&id=7731e86d&scoped=true&"
import script from "./AssistantService.vue?vue&type=script&lang=js&"
export * from "./AssistantService.vue?vue&type=script&lang=js&"
import style0 from "./AssistantService.vue?vue&type=style&index=0&id=7731e86d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7731e86d",
  null
  
)

export default component.exports